import * as ko from "knockout";
import * as _ from "lodash";
import { c_sap_sales_order } from "../c_sap_sales_order";
import entityBase from "entityBase";

export class complaint_request_header extends entityBase {
  complaint_id: KnockoutObservable<string>;
  complaint_type: KnockoutObservable<string>;
  // Complaint List
  is_goodwill: KnockoutObservable<string>;
  original_delivery_order: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  complaint_status: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<string>;
  person: KnockoutObservable<string>;
  owner_ref_no: KnockoutObservable<string>;
  total_lines: KnockoutObservable<number>;
  claimed_lines: KnockoutObservable<number>;
  // TONER_COMPLAINT
  tonerc_error_msg: KnockoutObservable<boolean>;
  tonerc_leaks: KnockoutObservable<boolean>;
  tonerc_no_function: KnockoutObservable<boolean>;
  tonerc_bad_printout: KnockoutObservable<boolean>;
  tonerc_tech_problems: KnockoutObservable<boolean>;
  tonerc_other: KnockoutObservable<boolean>;
  tonerc_explain_complain: KnockoutObservable<string>;
  tonerc_comment_on_other: KnockoutObservable<string>;
  // WRONG_DELIVERY
  wrongd_wrong_article: KnockoutObservable<boolean>;
  wrongd_wrong_qty: KnockoutObservable<boolean>;
  wrongd_wrong_serialno: KnockoutObservable<boolean>;
  wrongd_other: KnockoutObservable<boolean>;
  wrongd_description: KnockoutObservable<string>;
  // RETURN_REQUEST
  retr_description: KnockoutObservable<string>;
  retr_support_ticker: KnockoutObservable<string>;
  // TRANSPORT_DAMAGE
  transptd_kindof_damage: KnockoutObservable<string>;
  transptd_description: KnockoutObservable<string>;
  // WRONG_GOODS_RECEIVED
  foreigngds_description: KnockoutObservable<string>;
  // Pick-Up Address
  addr_company: KnockoutObservable<string>;
  addr_street: KnockoutObservable<string>;
  addr_house_no: KnockoutObservable<string>;
  addr_zip: KnockoutObservable<string>;
  addr_city: KnockoutObservable<string>;
  // Contact Person
  contact_name: KnockoutObservable<string>;
  contact_phone: KnockoutObservable<string>;
  contact_email: KnockoutObservable<string>;
  // notifications
  att_notifications: KnockoutObservable<any>;
  notes_notifications: KnockoutObservable<any>;

  c_sap_sales_order: KnockoutObservableArray<c_sap_sales_order>;

  constructor(item) {
    super();
    this.complaint_id = ko.observable(item.complaint_id);
    this.complaint_type = ko.observable(item.complaint_type);
    // Complaint List
    this.is_goodwill = ko.observable(item.is_goodwill ? item.is_goodwill : "");
    this.original_delivery_order = ko.observable(item.original_delivery_order ? item.original_delivery_order : "");
    this.status = ko.observable(item.status ? item.status : "");
    this.complaint_status = ko.observable(item.complaint_status ? item.complaint_status : "");
    if (item.created_dttm) {
      let options = new Intl.DateTimeFormat(undefined, { year: "numeric", month: "long", day: "numeric" });
      let created_date = options.format(new Date(item.created_dttm));
      this.created_dttm = ko.observable(created_date);
    }
    this.person = ko.observable(item.person ? item.person.first_name + "" + item.person.last_name : "");
    this.owner_ref_no = ko.observable(item.owner_ref_no ? item.owner_ref_no : "");
    if (item.c_complaint_request_lines) {
      let claimed = _.filter(item.c_complaint_request_lines, ["selection", "Y"]);
      this.total_lines = ko.observable(item.c_complaint_request_lines.length);
      this.claimed_lines = ko.observable(claimed.length);
    } else {
      this.total_lines = ko.observable(0);
      this.claimed_lines = ko.observable(0);
    }

    this.tonerc_error_msg = ko.observable(item.tonerc_error_msg == "Y" ? true : false);
    this.tonerc_leaks = ko.observable(item.tonerc_leaks == "Y" ? true : false);
    this.tonerc_no_function = ko.observable(item.tonerc_no_function == "Y" ? true : false);
    this.tonerc_bad_printout = ko.observable(item.tonerc_bad_printout == "Y" ? true : false);
    this.tonerc_tech_problems = ko.observable(item.tonerc_tech_problems == "Y" ? true : false);
    this.tonerc_other = ko.observable(item.tonerc_other == "Y" ? true : false);
    this.tonerc_explain_complain = ko.observable(item.tonerc_explain_complain);
    this.tonerc_comment_on_other = ko.observable(item.tonerc_comment_on_other);

    this.wrongd_wrong_article = ko.observable(item.wrongd_wrong_article == "Y" ? true : false);
    this.wrongd_wrong_qty = ko.observable(item.wrongd_wrong_qty == "Y" ? true : false);
    this.wrongd_wrong_serialno = ko.observable(item.wrongd_wrong_serialno == "Y" ? true : false);
    this.wrongd_other = ko.observable(item.wrongd_other == "Y" ? true : false);
    this.wrongd_description = ko.observable(item.wrongd_description);

    this.retr_description = ko.observable(item.retr_description);
    this.retr_support_ticker = ko.observable(item.retr_support_ticker);

    this.transptd_kindof_damage = ko.observable(item.transptd_kindof_damage);
    this.transptd_description = ko.observable(item.transptd_description);

    this.foreigngds_description = ko.observable(item.foreigngds_description);

    this.addr_company = ko.observable(item.addr_company);
    this.addr_street = ko.observable(item.addr_street);
    this.addr_house_no = ko.observable(item.addr_house_no);
    this.addr_zip = ko.observable(item.addr_zip);
    this.addr_city = ko.observable(item.addr_city);

    this.contact_name = ko.observable(item.contact_name);
    this.contact_phone = ko.observable(item.contact_phone);
    this.contact_email = ko.observable(item.contact_email);

    this.notes_notifications = ko.observable(
      [item?.ext_new_note_for_customer, item?.ext_new_note_for_partner].some((o) => o === "Y") || null,
    );
    this.att_notifications = ko.observable(item?.ext_new_public_attachment === "Y" || null);

    this.c_sap_sales_order = <KnockoutObservableArray<c_sap_sales_order>>(
      this.loadRelation(item, c_sap_sales_order, "c_sap_sales_order", "array")
    );
  }
}
